import CreateTokenView from './CreateTokenView'

export default CreateTokenView
